import { useRef } from 'react';
import { Row, Col, Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';
import { MemberMultiSelectDropdown, ProjectListDropdown } from '../common';

const DeleteSchedules = ({
  teamMembersList,
  showDeleteSchedules,
  handleShowDeleteSchedules,
  handleDeleteBulkSchedules,
  projectsList,
  selectedProject,
  handleProjectChange,
}) => {
  const selectedTeamMembers = [];
  const sortedMembersList = teamMembersList.filter(function (el) {
    return el.status !== 'inactive';
  });
  const deleteSchedulesSelectInputRef = useRef(null);
  const datePickerOptions = {
    allowInvalidPreload: true,
    dateFormat: 'M j, Y',
    monthSelectorType: 'static',
  };

  // Clear the team member field when project changes
  const clearTeamMemberFiled = () => {
    if (!deleteSchedulesSelectInputRef.current) return;
    deleteSchedulesSelectInputRef.current.select.clearValue();
  };

  return (
    <>
      <Dropdown.Item
        onClick={() => {
          handleShowDeleteSchedules(true);
        }}
      >
        Delete Schedule
      </Dropdown.Item>

      <Modal
        show={showDeleteSchedules}
        onHide={() => {
          handleShowDeleteSchedules(false);
        }}
        centered
      >
        <Modal.Header>
          <Modal.Title className="m-0">Delete Schedule</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              handleShowDeleteSchedules(false);
            }}
          />
        </Modal.Header>
        <Formik
          enableReinitialize
          initialValues={{
            projectId:
              selectedProject?.value !== 'all' ? selectedProject?.value : '',
            selectedMembers: selectedTeamMembers,
            fromDate: '',
            toDate: '',
          }}
          validationSchema={Yup.object({
            selectedMembers: Yup.array().min(1, 'Please select a team member'),
            fromDate: Yup.date().required('Please select schedule from date'),
            toDate: Yup.date()
              .required('Please select schedule to date')
              .min(
                Yup.ref('fromDate'),
                'End date must be later than or equal to from date'
              ),
          })}
          onSubmit={(values) => {
            handleDeleteBulkSchedules(values);
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Modal.Body>
                <section>
                  <ProjectListDropdown
                    fieldName="projectId"
                    projectsList={projectsList}
                    handleChange={formikprops.handleChange}
                    handleProjectChange={handleProjectChange}
                    isDependedField
                    otherActions={clearTeamMemberFiled}
                  />
                  <MemberMultiSelectDropdown
                    id="deleteSchedulesSelectInputRef"
                    name="selectedMembers"
                    labelText="Team Member(s)"
                    fromArray={sortedMembersList}
                    formProps={formikprops}
                    isDisabled={sortedMembersList.length < 1 && true}
                    innerRef={deleteSchedulesSelectInputRef}
                    isAllTeamMemberOption
                    requiredValueAs="userId"
                    showErrorMessage
                  />
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="fromDate">
                        <Form.Label>From Date</Form.Label>
                        <Flatpickr
                          onChange={([date]) => {
                            formikprops.setFieldValue('fromDate', date);
                          }}
                          placeholder=""
                          options={datePickerOptions}
                          className="form-control icon-calendar due-date"
                          name="fromDate"
                        />
                        <ErrorMessage
                          name="fromDate"
                          render={(msg) => (
                            <small className="text-danger">{msg}</small>
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="toDate">
                        <Form.Label>To Date</Form.Label>
                        <Flatpickr
                          onChange={([date]) => {
                            formikprops.setFieldValue('toDate', date);
                          }}
                          placeholder=""
                          options={datePickerOptions}
                          className="form-control icon-calendar due-date"
                          name="toDate"
                        />
                        <ErrorMessage
                          name="toDate"
                          render={(msg) => (
                            <small className="text-danger">{msg}</small>
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </section>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <Button
                  variant="link"
                  onClick={() => {
                    handleShowDeleteSchedules(false);
                  }}
                >
                  Cancel
                </Button>
                <Button variant="primary" type="submit">
                  Delete Schedules
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

DeleteSchedules.propTypes = {
  teamMembersList: PropTypes.array,
  showDeleteSchedules: PropTypes.bool,
  handleShowDeleteSchedules: PropTypes.func,
  handleDeleteBulkSchedules: PropTypes.func,
  projectsList: PropTypes.array,
  selectedProject: PropTypes.object,
  handleProjectChange: PropTypes.func,
};

export default DeleteSchedules;
